"use client";

import React from "react";

export default function DataTable({
  columns,
  data,
  isLoading,
  emptyMessage = "No records",
  getRowKey = (row, i) => row.id ?? i,
  onRowClick,
  footer,
}) {
  return (
    <div className="overflow-hidden rounded-2xl border border-gray-200/90 dark:border-gray-800 bg-white dark:bg-gray-900/40 shadow-theme-sm">
      <div className="overflow-x-auto">
        <table className="min-w-full text-left text-xs">
          <thead>
            <tr className="border-b border-gray-200 dark:border-gray-800 bg-linear-to-b from-gray-50 to-gray-100 dark:from-gray-950 dark:to-gray-900">
              {columns.map((col) => (
                <th
                  key={col.key}
                  className={`px-4 py-3 font-semibold tracking-wide text-gray-600 dark:text-gray-500 whitespace-nowrap ${col.headerClassName || ""}`}
                >
                  {col.header}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {isLoading ? (
              <tr>
                <td
                  colSpan={columns.length}
                  className="px-4 py-10 text-center text-gray-500 dark:text-gray-500"
                >
                  Loading…
                </td>
              </tr>
            ) : data.length === 0 ? (
              <tr>
                <td
                  colSpan={columns.length}
                  className="px-4 py-10 text-center text-gray-500 dark:text-gray-500"
                >
                  {emptyMessage}
                </td>
              </tr>
            ) : (
              data.map((row, i) => (
                <tr
                  key={getRowKey(row, i)}
                  className={`border-b border-gray-200 dark:border-gray-800/80 last:border-0 ${
                    onRowClick
                      ? "cursor-pointer hover:bg-gray-50 dark:hover:bg-white/3 data-[active=true]:bg-gray-100 dark:data-[active=true]:bg-white/5"
                      : ""
                  }`}
                  onClick={() => onRowClick?.(row)}
                >
                  {columns.map((col) => (
                    <td
                      key={col.key}
                      className={`px-4 py-3 text-gray-700 dark:text-gray-300 whitespace-nowrap ${col.cellClassName || ""}`}
                    >
                      {col.render ? col.render(row) : row[col.key]}
                    </td>
                  ))}
                </tr>
              ))
            )}
          </tbody>
          {footer && !isLoading && data.length > 0 && (
            <tfoot>
              <tr className="border-t border-gray-200 dark:border-gray-800 bg-gray-50 dark:bg-gray-950/90">
                {footer}
              </tr>
            </tfoot>
          )}
        </table>
      </div>
    </div>
  );
}
